import React, { useState, useEffect } from "react";

import { Container, Row, Col, Form } from "react-bootstrap";
import ButtonLoader from "components/Common/ButtonLoader";
import { Link, useHistory } from "react-router-dom";
import {
  CreateFranchiseRecord,
  EditFranchiseRecord,
} from "../../services/FranchiseService";
import { checkPermissionStatus } from "helpers/utils";
import { decryptDataFromArray, encryptDataToArray } from "helpers/EncDec";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { GetCompanyData } from "services/CompanyService";
import {
  FetchLocationList,
  FetchRegionList,
  FetchStateList,
} from "services/locationService";
import Select from "react-select";
import { toast } from "react-toastify";
import { MultiSelect } from "react-multi-select-component";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import api from "../../api";

const CreateFranchise = props => {
  const { t } = useTranslation();
  const history = useHistory();
  const { state } = useLocation();
  const { formMode, data } = state || {};
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [FranchisePayload, setFranchisePayload] = useState({
    status: formMode == "view" || formMode == "edit" ? data?.franchise_details?.status : "1",
    franchise_email:
      formMode == "view" || formMode == "edit"
        ? data?.franchise_details?.franchise_email
        : "",
    franchise_name:
      formMode == "view" || formMode == "edit"
        ? data?.franchise_details?.franchise_name
        : "",
    franchise_username:
      formMode == "view" || formMode == "edit"
        ? data?.franchise_details?.franchise_username
        : "",
    country_id:
      formMode == "view" || formMode == "edit"
        ? data?.franchise_details?.country_id
        : "",
    region_ids:
      formMode == "view" || formMode == "edit"
        ? data?.franchise_details?.region_ids
        : [],
    state_ids:
      formMode == "view" || formMode == "edit"
        ? data?.franchise_details?.state_ids
        : [],
    city_ids:
      formMode == "view" || formMode == "edit"
        ? data?.franchise_details?.city_ids
        : [],
    location_ids:
      formMode == "view" || formMode == "edit"
        ? data?.franchise_details?.location_ids
        : [],
  });
  const [CountryData, setCountryData] = useState([]);
  const [countryIdSelected, setCountryIdSelected] = useState(false);
  const [RegionData, setRegionData] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [StateData, setStateData] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [CityData, setCityData] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [LocationData, setLocationData] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);

  const handleInput = event => {
    const { name, value } = event.target;

    setFranchisePayload(prevState => ({
      ...prevState,
      [name]: value,
    }));

    let error = errors;
    error[name] = "";
    setErrors(error);
  };

  const editFranchise = payload => {
    EditFranchiseRecord(payload)
      .then(response => {
        setIsLoading(false);
        history.push("/franchise-list");
      })
      .catch(err => {
        setIsLoading(false);

        let msg =
          err?.response?.data?.message ||
          err?.message ||
          "Unable to create city";
        toast.error(msg);

        if (Object.keys(err?.response?.data?.message?.errors || {})?.length) {
          setErrors(err?.response?.data?.message?.errors || {});
        }
      });
  };

  const createNewFranchise = payload => {
    CreateFranchiseRecord(payload)
      .then(response => {
        setIsLoading(false);
        history.push("/franchise-list");
      })
      .catch(err => {
        setIsLoading(false);

        let msg =
          err?.response?.data?.message ||
          err?.message ||
          "Unable to create city";
        toast.error(msg);

        if (Object.keys(err?.response?.data?.message?.errors || {})?.length) {
          setErrors(err?.response?.data?.message?.errors || {});
        }
      });
  };
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const validateUserName = txtMobId => {
    if (!txtMobId) {
      return "Code is required";
    }

    let nameRegex = /^[a-zA-Z0-9._]{3,20}$/;
    if (!nameRegex.test(txtMobId)) {
      return "Valid Code is required";
    }

    return "";
  };

  const validateName = txtMobId => {
    if (!txtMobId) {
      return "Name is required";
    }

    let nameRegex = /^(?=.{2,50}$)[A-Za-z]+(?:[ .][A-Za-z]+)*\.?$/;
    if (!nameRegex.test(txtMobId)) {
      return "Valid Name is required";
    }

    return "";
  };

  const validateEmail = value => {
    if (!value) {
      return "Email is required";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return "Valid Email is required";
    }

    return "";
  };

  const handleSubmit = event => {
    event.preventDefault();
    setErrors({});
    setIsLoading(true);
    let errorObj = {};

    if (!FranchisePayload?.country_id) {
      errorObj["country_id"] = "Country is required";
    }

    if (!!validateUserName(FranchisePayload?.franchise_username)) {
      errorObj.franchise_username = validateUserName(
        FranchisePayload?.franchise_username
      );
    }

    if (!!validateName(FranchisePayload?.franchise_name)) {
      errorObj.franchise_name = validateName(FranchisePayload?.franchise_name);
    }

    if (!!validateEmail(FranchisePayload?.franchise_email)) {
      errorObj.franchise_email = validateEmail(
        FranchisePayload?.franchise_email
      );
    }

    if (Object.keys(errorObj)?.length > 0) {
      setIsLoading(false);
      setErrors(prevState => ({
        ...prevState,
        ...errorObj,
      }));

      console.log("errorObj", errorObj);

      return;
    }

    const reqData = {
      country_id: FranchisePayload?.country_id,
      region_ids: FranchisePayload?.region_ids || [],
      state_ids: FranchisePayload?.state_ids || [],
      city_ids: FranchisePayload?.city_ids || [],
      location_ids: FranchisePayload?.location_ids || [],
      franchise_username: FranchisePayload?.franchise_username,
      franchise_name: FranchisePayload?.franchise_name,
      franchise_email: FranchisePayload?.franchise_email,
      status: FranchisePayload?.status,
    };

if (formMode === "edit") {
  reqData.id = data?.franchise_details?.id ?? null;
}
  const encryptedData = encryptDataToArray(reqData);

    let payload = new FormData();
    payload.append("reqData", JSON.stringify(encryptedData));

    formMode == "edit" ? editFranchise(payload) : createNewFranchise(payload);
  };

  const fetchCountryData = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/location/country-list`)
      .then(response => {
        const { success, allCountry } = response.data;
        if (success) {
          const { allCountry } = response.data;
          let data = allCountry?.map(item => ({
            id: item?.id,
            label: item?.name,
            value: item?.id,
          }));
          setCountryData(data);
        }
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchRegionData = () => {
    FetchRegionList()
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const allRegion = response?.data?.filter(item => item.status === 1) || [];
        let data = allRegion?.map(item => ({
          id: item?.id,
          label: item?.region,
          value: item?.id,
          country_id: item?.country_id,
        }));
        setRegionData(data);
        if (formMode == "view" || formMode == "edit") {
          setSelectedRegions(
            data?.filter(item =>
              FranchisePayload?.region_ids?.includes(item?.id)
            )
          );
        }
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchStateData = () => {
    FetchStateList()
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const StateList = response?.data?.filter(item => item.status === 1) || [];
        let data = StateList?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.id,
          country_id: item?.country_id,
          region_id: item?.region_id,
        }));
        setStateData(data);
        if (formMode == "view" || formMode == "edit") {
          setSelectedStates(
            data?.filter(item =>
              FranchisePayload?.state_ids?.includes(item?.id)
            )
          );
        }
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchCityData = async () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/location/city-list`)
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const CityList = response?.data?.filter(item => item.status === 1) || [];
        let data = CityList?.map(item => ({
          id: item?.id,
          label: item?.city,
          value: item?.id,
          country_id: item?.country_id,
          region_id: item?.region_id,
          state_id: item?.state_id,
        }));
        setCityData(data);
        if (formMode == "view" || formMode == "edit") {
          setSelectedCities(
            data?.filter(item => FranchisePayload?.city_ids?.includes(item?.id))
          );
        }
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchLocationData = () => {
    FetchLocationList()
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const locationList = response?.data?.filter(item => item.status === 1) || [];
        let data = locationList?.map(item => ({
          id: item?.id,
          label: item?.label,
          value: item?.value,
          country_id: item?.country_id,
          region_id: item?.region_id,
          state_id: item?.state_id,
          city_id: item?.city_id,
        }));
        setLocationData(data);
        if (formMode == "view" || formMode == "edit") {
          setSelectedLocations(
            data?.filter(item =>
              FranchisePayload?.location_ids?.includes(item?.id)
            )
          );
        }
      })
      .catch(err => console.log("Error:::", err));
  };

  const handleCountrySelection = CountryID => {
    setFranchisePayload(prevState => ({
      ...prevState,
      country_id: CountryID,
      region_id: null,
      state_id: null,
      city_id: null,
    }));
  };

  const handleSelectAllRegions = () => {
    setSelectedRegions(RegionData);

    let regionIds = RegionData?.map(reg => reg?.id);
    setFranchisePayload(prev => ({
      ...prev,
      region_ids: regionIds,
    }));
  };
  const handleDeselectAllRegions = () => {
    setSelectedRegions([]);
    setSelectedStates([]);
    setSelectedCities([]);
    setSelectedLocations([]);

    setFranchisePayload(prev => ({
      ...prev,
      region_ids: [],
      state_ids: [],
      city_ids: [],
      location_ids: [],
    }));
  };
  const handleChangeRegions = regions => {
    if (!regions?.length) {
      handleDeselectAllRegions();

      return;
    }

    setSelectedRegions(regions);

    let regionIds = regions?.map(reg => reg?.id);

    let tempStates = selectedStates?.filter(state =>
      regionIds?.includes(state?.region_id)
    );
    setSelectedStates(tempStates);

    let stateIds = tempStates?.map(state => state?.id);
    let tempCities = selectedCities?.filter(
      city =>
        regionIds?.includes(city?.region_id) &&
        stateIds?.includes(city?.state_id)
    );
    setSelectedCities(tempCities);

    let cityIds = tempCities?.map(city => city?.id);
    let tempLocations = selectedLocations?.filter(
      loc =>
        regionIds?.includes(loc?.region_id) &&
        stateIds?.includes(loc?.state_id) &&
        cityIds?.includes(loc?.city_id)
    );
    setSelectedCities(tempLocations);

    let locationIds = tempLocations?.map(loc => loc?.id);

    setFranchisePayload(prev => ({
      ...prev,
      region_ids: regionIds,
      state_ids: stateIds,
      city_ids: cityIds,
      location_ids: locationIds,
    }));
  };

  const handleSelectAllStates = () => {
    let tempStateData = StateData;

    if (!!FranchisePayload?.region_ids?.length) {
      tempStateData = tempStateData?.filter(state =>
        FranchisePayload?.region_ids?.includes(state?.region_id)
      );
    }

    tempStateData = tempStateData?.filter(
      state => state?.country_id === FranchisePayload?.country_id
    );
    setSelectedStates(tempStateData);

    let stateIds = tempStateData?.map(state => state?.id);

    setFranchisePayload(prev => ({
      ...prev,
      state_ids: stateIds,
    }));
  };
  const handleDeselectAllStates = () => {
    setSelectedStates([]);
    setSelectedCities([]);
    setSelectedLocations([]);

    setFranchisePayload(prev => ({
      ...prev,
      state_ids: [],
      city_ids: [],
      location_ids: [],
    }));
  };
  const handleChangeStates = states => {
    if (!states?.length) {
      handleDeselectAllStates();

      return;
    }

    setSelectedStates(states);

    let stateIds = states?.map(state => state?.id);
    let tempCities = selectedCities?.filter(city =>
      stateIds?.includes(city?.state_id)
    );
    setSelectedCities(tempCities);

    let cityIds = tempCities?.map(city => city?.id);
    let tempLocations = selectedLocations?.filter(
      loc =>
        stateIds?.includes(loc?.state_id) && cityIds?.includes(loc?.city_id)
    );
    setSelectedLocations(tempLocations);

    let locationIds = tempLocations?.map(loc => loc?.id);

    setFranchisePayload(prev => ({
      ...prev,
      state_ids: stateIds,
      city_ids: cityIds,
      location_ids: locationIds,
    }));
  };

  const handleSelectAllCities = () => {
    let tempCityData = CityData;

    if (!!FranchisePayload?.region_ids?.length) {
      tempCityData = tempCityData?.filter(city =>
        FranchisePayload?.region_ids?.includes(city?.region_id)
      );
    }

    tempCityData = tempCityData?.filter(
      city =>
        city?.country_id === FranchisePayload?.country_id &&
        FranchisePayload?.state_ids?.includes(city?.state_id)
    );
    setSelectedCities(tempCityData);

    let cityIds = tempCityData?.map(reg => reg?.id);

    setFranchisePayload(prev => ({
      ...prev,
      city_ids: cityIds,
    }));
  };
  const handleDeselectAllCities = () => {
    setSelectedCities([]);
    setSelectedLocations([]);

    setFranchisePayload(prev => ({
      ...prev,
      city_ids: [],
      location_ids: [],
    }));
  };
  const handleChangeCities = cities => {
    if (!cities?.length) {
      handleDeselectAllCities();

      return;
    }

    setSelectedCities(cities);

    let cityIds = cities?.map(city => city?.id);
    let tempLocations = selectedLocations?.filter(loc =>
      cityIds?.includes(loc?.city_id)
    );
    setSelectedLocations(tempLocations);

    let locationIds = tempLocations?.map(loc => loc?.id);

    setFranchisePayload(prev => ({
      ...prev,
      city_ids: cityIds,
      location_ids: locationIds,
    }));
  };

  const handleSelectAllLocations = () => {
    let tempLocationData = LocationData;

    if (!!FranchisePayload?.region_ids?.length) {
      tempLocationData = tempLocationData?.filter(loc =>
        FranchisePayload?.region_ids?.includes(loc?.region_id)
      );
    }

    tempLocationData = tempLocationData?.filter(
      loc =>
        loc?.country_id === FranchisePayload?.country_id &&
        FranchisePayload?.state_ids?.includes(loc?.state_id) &&
        FranchisePayload?.city_ids?.includes(loc?.city_id)
    );
    setSelectedLocations(tempLocationData);

    let locationIds = tempLocationData?.map(loc => loc?.id);

    setFranchisePayload(prev => ({
      ...prev,
      location_ids: locationIds,
    }));
  };
  const handleDeselectAllLocations = () => {
    setSelectedLocations([]);

    setFranchisePayload(prev => ({
      ...prev,
      location_ids: [],
    }));
  };
  const handleChangeLocations = locations => {
    if (!locations?.length) {
      handleDeselectAllLocations();

      return;
    }

    setSelectedLocations(locations);

    let locationIds = locations?.map(loc => loc?.id);

    setFranchisePayload(prev => ({
      ...prev,
      location_ids: locationIds,
    }));
  };

  useEffect(() => {
    GetCompanyData()
      .then(res => {
        let companyData = res?.data?.data || {};

        setFranchisePayload(prevState => ({
          ...prevState,
          country_id: companyData?.country_id,
        }));

        if (companyData?.country_id) {
          setCountryIdSelected(true);
        }
      })
      .catch(err => {});

    fetchCountryData();
    fetchRegionData();
    fetchStateData();
    fetchCityData();
    fetchLocationData();

    return () => {};
  }, []);

  if (!checkPermissionStatus("franchise-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

  return (
    <div className="page-content only-form-padding">
      <Container fluid>
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center">
            <Col lg="6" md="6">
              <Link to="/franchise-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {formMode === "view"
                    ? t(`Franchise.View Franchise`)
                    : formMode === "edit"
                    ? t(`Franchise.Edit Franchise`)
                    : t(`Franchise.Create Franchise`)}
                </h5>
              </Link>
            </Col>
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-3">
            <Row>
              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Franchise.Country`)}
                  <span className="text-danger">*</span>
                </Form.Label>

                <select
                  type="select"
                  name="country_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={e => handleCountrySelection(e.target?.value)}
                  value={FranchisePayload?.country_id}
                  disabled={countryIdSelected === true}
                  placeholder={t(`Franchise.Country`)}
                  title={
                    CountryData.find(
                      el => el?.id === FranchisePayload?.country_id
                    )?.label || t(`Location_Manager.Select Country`)
                  }
                >
                  <option value="" selected>
                    {t(`Franchise.Select Country`)}
                  </option>
                  {CountryData &&
                    CountryData.map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.country_id && (
                  <small className="text-danger"> {errors?.country_id} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Franchise.Region`)}
                </Form.Label>

                <div
                  title={
                    selectedRegions.length > 0
                      ? `${selectedRegions
                          .map(region => region.label)
                          .join(", ")}`
                      : `${t(`Franchise.Region`).toLowerCase()}`
                  }
                >
                  <MultiSelect
                    // isMulti
                    overrideStrings={{
                      selectSomeItems: t(`Resource Pool.Select`),
                      allItemsAreSelected: t(
                        "Resource Pool.All items are selected"
                      ),
                      search: t("Resource Pool.Search"),
                      selectAll: t("Resource Pool.Select All"),
                    }}
                    placeholder={t(`Franchise.Region`)}
                    options={[
                      ...RegionData?.filter(
                        region =>
                          !FranchisePayload?.country_id ||
                          region?.country_id === FranchisePayload?.country_id
                      ),
                    ]}
                    value={selectedRegions}
                    onChange={
                      formMode != "view" ? handleChangeRegions : () => {}
                    }
                    disabled={formMode == "view"}
                  />
                </div>
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Franchise.State`)}
                </Form.Label>
                <div
                  title={
                    selectedStates.length > 0
                      ? `${selectedStates
                          .map(region => region.label)
                          .join(", ")}`
                      : `${t(`Franchise.State`).toLowerCase()}`
                  }
                >
                  <MultiSelect
                    // isMulti
                    overrideStrings={{
                      selectSomeItems: t(`Resource Pool.Select`),
                      allItemsAreSelected: t(
                        "Resource Pool.All items are selected"
                      ),
                      search: t("Resource Pool.Search"),
                      selectAll: t("Resource Pool.Select All"),
                    }}
                    placeholder={t(`Resource Pool.Select`)}
                    options={[
                      ...StateData?.filter(
                        state =>
                          !FranchisePayload?.country_id ||
                          (!FranchisePayload?.region_ids?.length &&
                            state?.country_id ===
                              FranchisePayload?.country_id) ||
                          (state?.country_id === FranchisePayload?.country_id &&
                            FranchisePayload?.region_ids?.includes(
                              state?.region_id
                            ))
                      ),
                    ]}
                    value={selectedStates}
                    onChange={
                      formMode != "view" ? handleChangeStates : () => {}
                    }
                    disabled={formMode == "view"}
                  />
                </div>
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Franchise.City`)}
                </Form.Label>

                <div
                  title={
                    selectedCities.length > 0
                      ? `${selectedCities
                          .map(region => region.label)
                          .join(", ")}`
                      : `${t(`Franchise.City`).toLowerCase()}`
                  }
                >
                  <MultiSelect
                    // isMulti
                    overrideStrings={{
                      selectSomeItems: t(`Resource Pool.Select`),
                      allItemsAreSelected: t(
                        "Resource Pool.All items are selected"
                      ),
                      search: t("Resource Pool.Search"),
                      selectAll: t("Resource Pool.Select All"),
                    }}
                    placeholder={t(`Resource Pool.Select`)}
                    options={[
                      // {
                      //   isDisabled: true,
                      //   value: null,
                      //   label: (
                      //     <div className="d-flex gap-2">
                      //       <button
                      //         className="selectall-btn"
                      //         onClick={handleSelectAllCities}
                      //       >
                      //         Select All
                      //       </button>
                      //       <button
                      //         className="selectall-btn"
                      //         onClick={handleDeselectAllCities}
                      //       >
                      //         Deselect All
                      //       </button>
                      //     </div>
                      //   ),
                      // },
                      ...CityData?.filter(
                        city =>
                          !FranchisePayload?.country_id ||
                          (!FranchisePayload?.region_ids?.length &&
                            city?.country_id === FranchisePayload?.country_id &&
                            FranchisePayload?.state_ids?.includes(
                              city?.state_id
                            )) ||
                          (city?.country_id === FranchisePayload?.country_id &&
                            FranchisePayload?.region_ids?.includes(
                              city?.region_id
                            ) &&
                            FranchisePayload?.state_ids?.includes(
                              city?.state_id
                            ))
                      ),
                    ]}
                    value={selectedCities}
                    onChange={
                      formMode != "view" ? handleChangeCities : () => {}
                    }
                    disabled={formMode == "view"}
                  />
                </div>
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Franchise.Area`)}
                </Form.Label>

                <div
                  title={
                    selectedLocations.length > 0
                      ? `${selectedLocations
                          .map(region => region.label)
                          .join(", ")}`
                      : `${t(`Franchise.Area`).toLowerCase()}`
                  }
                >
                  <MultiSelect
                    isMulti
                    overrideStrings={{
                      selectSomeItems: t(`Resource Pool.Select`),
                      allItemsAreSelected: t(
                        "Resource Pool.All items are selected"
                      ),
                      search: t("Resource Pool.Search"),
                      selectAll: t("Resource Pool.Select All"),
                    }}
                    placeholder={t(`Resource Pool.Select`)}
                    options={[
                      // {
                      //   isDisabled: true,
                      //   value: null,
                      //   label: (
                      //     <div className="d-flex gap-2">
                      //       <button
                      //         className="selectall-btn"
                      //         onClick={handleSelectAllLocations}
                      //       >
                      //         Select All
                      //       </button>
                      //       <button
                      //         className="selectall-btn"
                      //         onClick={handleDeselectAllLocations}
                      //       >
                      //         Deselect All
                      //       </button>
                      //     </div>
                      //   ),
                      // },
                      ...LocationData?.filter(
                        loc =>
                          !FranchisePayload?.country_id ||
                          (!FranchisePayload?.region_ids?.length &&
                            loc?.country_id === FranchisePayload?.country_id &&
                            FranchisePayload?.state_ids?.includes(
                              loc?.state_id
                            ) &&
                            FranchisePayload?.city_ids?.includes(
                              loc?.city_id
                            )) ||
                          (loc?.country_id === FranchisePayload?.country_id &&
                            FranchisePayload?.region_ids?.includes(
                              loc?.region_id
                            ) &&
                            FranchisePayload?.state_ids?.includes(
                              loc?.state_id
                            ) &&
                            FranchisePayload?.city_ids?.includes(loc?.city_id))
                      ),
                    ]}
                    value={selectedLocations}
                    onChange={
                      formMode != "view" ? handleChangeLocations : () => {}
                    }
                    disabled={formMode == "view"}
                  />
                </div>
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Franchise.Franchise Username`)}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Franchise.Franchise Username`)}
                  name="franchise_username"
                  value={FranchisePayload?.franchise_username}
                  disabled={formMode == "view"}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Franchise.Franchise Username`
                  ).toLowerCase()}`}
                />
                {errors?.franchise_username && (
                  <small className="text-danger">
                    {" "}
                    {errors?.franchise_username}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Franchise.Franchise Name`)}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Franchise.Franchise Name`)}
                  name="franchise_name"
                  value={FranchisePayload?.franchise_name}
                  disabled={formMode == "view"}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Franchise.Franchise Name`
                  ).toLowerCase()}`}
                />
                {errors?.franchise_name && (
                  <small className="text-danger">
                    {" "}
                    {errors?.franchise_name}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Franchise.Franchise Email`)}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Franchise.Franchise Email`)}
                  name="franchise_email"
                  value={FranchisePayload?.franchise_email}
                  disabled={formMode == "view"}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Franchise.Franchise Email`
                  ).toLowerCase()}`}
                />
                {errors?.franchise_email && (
                  <small className="text-danger">
                    {" "}
                    {errors?.franchise_email}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Franchise.Status`)}
                  <span className="text-danger">*</span>
                </Form.Label>
                <select
                  type="select"
                  name="status"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={handleInput}
                  value={FranchisePayload?.status}
                  disabled={formMode == "view"}
                  onMouseEnter={e => {
                    e.target.setAttribute(
                      "title",
                      e.target.options[e.target.selectedIndex].text
                    );
                  }}
                >
                  <option value="1">{t(`Franchise.Active`)}</option>
                  <option value="0">{t(`Franchise.Inactive`)}</option>
                </select>
                {errors?.status && (
                  <small className="text-danger"> {errors?.status} </small>
                )}
              </Form.Group>
            </Row>

            <Form.Group className="cta  gap-3 text-center d-flex justify-content-start mt-4 pb-2">
              <Link to="/franchise-list" className="btn btn-secondary">
                {formMode == "view"
                  ? t(`Franchise.Close`)
                  : t(`Franchise.Cancel`)}
              </Link>
              {formMode != "view" && (
                <ButtonLoader
                  title={
                    formMode == "edit"
                      ? t(`Franchise.Update Details`)
                      : t(`Franchise.Save Details`)
                  }
                  variant="primary"
                  type="submit"
                  loading={isLoading}
                  message={"Saving"}
                  onClick={e => {
                    handleSubmit(e);
                  }}
                />
              )}
            </Form.Group>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CreateFranchise;
